import NotFound from '../containers/Errors/NotFound';
import PrescriptionEmittedError from '../containers/Errors/PrescriptionEmitted';

const errorRoutes = [
  {
    path: '/notfound',
    component: NotFound,
  },
  {
    path: '/prescriptionemitted',
    component: PrescriptionEmittedError,
  },
];

export default errorRoutes;
